import React from 'react';
import Icon from 'components/AppIcon';

const PersonalInfoSection = ({ formData, errors, isArabic, onInputChange,onImageChange  }) => {
  return (
    <div className="mb-8">
      <div className="flex items-center mb-6">
        <div className="w-8 h-8 bg-green-100 rounded-lg flex items-center justify-center mr-3">
          <Icon name="User" size={20} color="#16a34a" />
        </div>
        <h2 className="text-xl font-semibold text-gray-900">
          {isArabic ? ' معلومات القسم' : 'Department Information '}
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Full Name */}
        <div className="md:col-span-2">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            {isArabic ? 'الاسم ' : 'name'}
            <span className="text-red-500 ml-1">*</span>
          </label>
          <input
            type="text"
            value={formData.name}
            onChange={(e) => onInputChange('name', e.target.value)}
            className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent transition-colors duration-200 ${
              errors.name ? 'border-red-500' : 'border-gray-300'
            }`}
            placeholder={isArabic ? 'أدخل الاسم الكامل' : 'Enter full name'}
          />
          {errors.name && (
            <p className="mt-1 text-sm text-red-600 flex items-center">
              <Icon name="AlertCircle" size={16} className="mr-1" />
              {errors.name}
            </p>
          )}
        </div>


    {/* Image Upload */}
<div>
  <label className="block text-sm font-medium text-gray-700 mb-2">
    {isArabic ? 'رفع صورة' : 'Upload Image'}
    <span className="text-red-500 ml-1">*</span>
  </label>
  <input
    type="file"
    accept="image/*"
    onChange={(e) => onImageChange(e.target.files[0])} // Assuming you have a function to handle image changes
    className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent transition-colors duration-200 ${
      errors.image ? 'border-red-500' : 'border-gray-300'
    }`}
  />
  {errors.image && (
    <p className="mt-1 text-sm text-red-600 flex items-center">
      <Icon name="AlertCircle" size={16} className="mr-1" />
      {errors.image}
    </p>
  )}
</div>



      </div>
    </div>
  );
};

export default PersonalInfoSection;